import React, { useState } from "react";
import { Button, Text, TextField } from "@telia/teddy";
import { useDispatch } from "react-redux";
import {
    sendCodeFromFormerLegal,
    verifyCodeFromFormerLegal,
} from "../../../checkout/state/actions/transferOwnershipActions";
import TEXT from "../../text-consts";

const PHONE_NUMBER_LENGTH = 8;

const OtpVerification: React.FC = () => {
    const dispatch = useDispatch();
    const [phoneNumber, setPhoneNumber] = useState("");
    const [pin, setPin] = useState("");
    const [isCodeSent, setIsCodeSent] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onlyDigits = phoneNumber.replace(/\s/g, "");
    const isValidPhoneNumber = /^\d+$/.test(onlyDigits) && onlyDigits.length === PHONE_NUMBER_LENGTH;

    const runAction = async (action: () => unknown, onSuccess?: () => void) => {
        setIsSubmitting(true);
        try {
            await action();
            onSuccess?.();
        } catch {
            // the error is shown by the alert on the page
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSendCode = () =>
        runAction(
            () => dispatch(sendCodeFromFormerLegal(onlyDigits)),
            () => {
                setIsCodeSent(true);
                setPin("");
            },
        );

    const handleVerifyCode = () => runAction(() => dispatch(verifyCodeFromFormerLegal(onlyDigits, pin)));

    return (
        <section className="consent-landing-page__otp">
            <Text mb="100" variant="additional-100">
                {TEXT.CONSENT_FORMER_LEGAL.OTP.DESCRIPTION}
            </Text>
            <TextField disabled={isCodeSent} className="consent-landing-page__otp-field">
                <TextField.Label>{TEXT.CONSENT_FORMER_LEGAL.OTP.PHONE_NUMBER_LABEL}</TextField.Label>
                <TextField.Input
                    type="tel"
                    data-di-mask
                    maxLength={PHONE_NUMBER_LENGTH}
                    value={phoneNumber}
                    onChange={(event) => setPhoneNumber(event.target.value)}
                />
            </TextField>
            {!isCodeSent && (
                <Button
                    size="sm"
                    variant="secondary"
                    disabled={!isValidPhoneNumber || isSubmitting}
                    onClick={handleSendCode}
                >
                    {TEXT.CONSENT_FORMER_LEGAL.OTP.SEND_CODE}
                </Button>
            )}
            {isCodeSent && (
                <>
                    <TextField className="consent-landing-page__otp-field">
                        <TextField.Label>{TEXT.CONSENT_FORMER_LEGAL.OTP.CODE_LABEL}</TextField.Label>
                        <TextField.Input
                            inputMode="numeric"
                            autoComplete="one-time-code"
                            value={pin}
                            onChange={(event) => setPin(event.target.value)}
                        />
                    </TextField>
                    <div className="consent-landing-page__otp-actions">
                        <Button size="sm" variant="primary" disabled={!pin || isSubmitting} onClick={handleVerifyCode}>
                            {TEXT.CONSENT_FORMER_LEGAL.OTP.VERIFY_CODE}
                        </Button>
                        <Button
                            size="sm"
                            variant="text"
                            disabled={isSubmitting}
                            onClick={() => {
                                setIsCodeSent(false);
                                setPin("");
                            }}
                        >
                            {TEXT.CONSENT_FORMER_LEGAL.OTP.CHANGE_NUMBER}
                        </Button>
                    </div>
                </>
            )}
        </section>
    );
};

export default OtpVerification;
